export default "__VITE_ASSET__CpPVa0sC__"